<template>
  <div v-if="$can('edit concierge advisers schedules')" class="mb-3 form-inline">
    <label class="my-1 mr-2 w-auto fw-600 col-form-label" for="weeksSelect">
      {{ $t('models/conciergeAdviserSchedulePeriods.schedule.week_count.label') }}:
    </label>

    <div class="input-group">
      <select v-model="updateWeeksForm.weeks" class="custom-select" id="weeksSelect">
        <option v-for="(label, value) in weeksOptions" :key="value" :value="value">
          {{ label }}
        </option>
      </select>
      <div class="input-group-append">
        <button
          type="submit"
          @click="submit()"
          class="btn btn-success"
          :disabled="disabled || updateWeeksForm.processing"
        >
          {{ $t('models/conciergeAdviserSchedulePeriods.schedule.week_count.submit_button') }}
          <i v-if="updateWeeksForm.processing" class="fa fa-spinner fa-spin"></i>
        </button>
      </div>
    </div>
    <div v-if="errorMessage" class="invalid-feedback d-block">
      {{ errorMessage }}
    </div>
    <div v-if="warningMessage" class="invalid-feedback text-orange d-block">
      {{ warningMessage }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { useForm } from '@inertiajs/vue3'
import { ref, watch } from 'vue'
import type { PropType } from 'vue'
import type { ConciergeAdviserSchedulePeriodData } from '~types/concierge-admin'

const errorMessage = ref<string>('')
const warningMessage = ref<string>('')
const disabled = ref<boolean>(true)
const updateWeeksForm = useForm({
  weeks: 1
})

const props = defineProps({
  adviserId: {
    type: Number,
    required: true
  },
  period: {
    type: Object as PropType<ConciergeAdviserSchedulePeriodData>,
    required: true
  },
  weeksOptions: {
    type: Object as PropType<{ [key: number]: string }>,
    required: true
  }
})

if (props.period.weeks) {
  updateWeeksForm.weeks = props.period.weeks
}

watch(
  () => updateWeeksForm.weeks,
  () => {
    if (Number(updateWeeksForm.weeks) !== Number(props.period.weeks)) {
      disabled.value = false
    } else {
      disabled.value = true
    }
  }
)

const submit = () => {
  updateWeeksForm.patch(
    route('conciergeAdvisers.schedules.period.weeks', [props.adviserId, props.period.id]),
    {
      onSuccess: () => {
        disabled.value = true
        errorMessage.value = ''
        warningMessage.value = ''
      },
      onError: errors => {
        disabled.value = true
        console.error(errors)
        errorMessage.value = errors.message || 'An error occurred while updating the weeks count'
      }
    }
  )
}
</script>
<style>
:root {
  --dp-input-padding: 2px;
}
</style>
